import React from 'react';
import {Stack, Typography} from '@mui/material';
import CoverageMetric from '../components/CoverageMetric';
import CoverageScoreRing from '../components/CoverageScoreRing';
import {analyticCountsText} from './buildAnalyticCoverageView';

/**
 * Analytic modal Overview: ICR headline % ring (same value as RHS card),
 * covered/partial counts, and optional linked/discovered breakdown.
 */
export default function AnalyticOverviewTab({view, computing = false}) {
    const countsText = view ? analyticCountsText(view) : '';
    const score = view?.headlinePct ?? view?.overallPct ?? null;
    const showBreakdown = !computing && view;
    return (
        <Stack spacing={3}>
            <Stack direction="row" spacing={2.5} alignItems="flex-start">
                <CoverageScoreRing
                    score={score}
                    computing={computing && score == null}
                    label={!computing && score == null ? '—' : undefined}
                />
                <Stack spacing={1} sx={{flex: 1, minWidth: 0}}>
                    {computing && !view ? (
                        <Typography variant="body2" color="text.secondary">
                            Computing analytic coverage…
                        </Typography>
                    ) : !view ? (
                        <Typography variant="body2" color="text.secondary">
                            Analytic coverage has not been computed for this ICR yet.
                        </Typography>
                    ) : (
                        <>
                            {view.summarySentence && (
                                <Typography variant="body2" color="text.secondary">
                                    {view.summarySentence}
                                </Typography>
                            )}
                            {countsText && (
                                <Typography variant="body2" fontWeight={600}>
                                    {countsText}
                                </Typography>
                            )}
                        </>
                    )}
                </Stack>
            </Stack>

            {showBreakdown && (
                <Stack direction="row" spacing={3} flexWrap="wrap" useFlexGap>
                    <CoverageMetric label="Linked FINTELs" value={view.linkedFintelCount}/>
                    <CoverageMetric label="FINTELs suggested by Minsky" value={view.discoveredCount}/>
                </Stack>
            )}
        </Stack>
    );
}
